"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CanvasIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m10.25 19-1.02 2.46a1 1 0 0 1-1.31.54.99.99 0 0 1-.54-1.3l.71-1.7zm5.43 0 .7 1.7a1 1 0 0 1-.54 1.31 1 1 0 0 1-1.31-.54L13.51 19z"/><path fill-rule="nonzero" d="M11 3a1 1 0 0 1 1-1c.55 0 1 .44 1 1v2h-2zM8 16h7.99C16 16 16 7 16 7H8.01C8 7 8 16 8 16M6 7c0-1.1.9-2 2.01-2h7.98C17.1 5 18 5.89 18 7v8.99A2.01 2.01 0 0 1 15.99 18H8.01A2 2 0 0 1 6 16z"/><rect width="14" height="2" x="5" y="16" rx="1"/><rect width="14" height="2" x="5" y="5" rx="1"/></g></svg>`
}, props));
CanvasIcon.displayName = 'CanvasIcon';
var _default = exports.default = CanvasIcon;